<template>
  <div class="box">
    <no-results
      :title="`Site deleted`"
      :message="
        `This site was deleted on ${dateDeleted}. All data relating to this site (notes, secrets, reports etc) will be permanently erased ${periodToDeletion}.`
      "
      icon="trash"
    />
    <div class="buttons has-padding-x-150">
      <router-link to="/sites" class="button is-rounded">
        <b-icon icon="arrow-left" size="is-small" />
        <span>Back</span>
      </router-link>
      <button
        class="button is-dark is-rounded"
        :class="{ 'is-loading': isProcessing }"
        :disabled="isProcessing"
        @click="restoreSite"
      >
        Restore site
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteStatusModal",
  props: {
    site: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isProcessing: false
    };
  },
  computed: {
    dateDeleted() {
      if (!this.site.dateDeleted) return "???";
      const dateDeleted = this.site.dateDeleted.toDate();
      return this.$moment(dateDeleted).format("MMMM Do, Y");
    },
    periodToDeletion() {
      if (!this.site.dateDeleted) return "???";
      const dateNow = this.$moment(new Date());
      const dateDeleted = this.site.dateDeleted.toDate();
      const hardDeleteDate = this.$moment(dateDeleted)
        .add(7, "days")
        .endOf("day");
      return hardDeleteDate.calendar(null, {
        sameDay: "[today]",
        nextDay: "[tomorrow]",
        nextWeek: `[in ${hardDeleteDate.diff(dateNow, "days")} days]`,
        sameElse: `[in ${hardDeleteDate.diff(dateNow, "days")} days]`
      });
    }
  },
  methods: {
    restoreSite() {
      this.isProcessing = true;
      this.$store
        .dispatch("sites/restoreSite", { siteId: this.site._id })
        .then(result => {
          this.$emit("close");
          this.$toast.open({
            message: result.message
          });
        })
        .catch(error => {
          this.isProcessing = false;
          this.$toast.open({
            message: `${error.message}`,
            type: "is-danger"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: space-between;
}
</style>
